

import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ColumnSchemaBase, ComponentContextService, DataListBase, ModelSchema, StateMachinesService } from 'tnx-shared';
@Component({
    selector: 'statemachines',
    templateUrl: './statemachines.component.html',
    styleUrls: ['./statemachines.component.scss'],
    providers: [ComponentContextService],
})
export class StateMachinesComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    constructor(
        protected _injector: Injector,
        protected _stateMachinesService: StateMachinesService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._stateMachinesService;
        this.setting.popupSize.maximize = true;
        this.setting.modelSchemas = [
            new ModelSchema({
                field: 'code',
                name: 'Mã quy trình',
                fullName: 'Mã quy trình',
                description: 'Mã quy trình',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'created',
                name: '',
                fullName: '',
                description: '',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'createdBy',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'currentStateCode',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'data',
                name: 'Dữ liệu',
                fullName: 'Dữ liệu',
                description: 'Dữ liệu',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'donViIdLastInWorkflow',
                name: '',
                fullName: '',
                description: '',
            }),
            new ModelSchema({
                field: 'entity',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'entityKey',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'id',
                name: '',
                fullName: '',
                description: '',
            }),
            new ModelSchema({
                field: 'isBuildIn',
                name: '',
                fullName: '',
                description: '',
                dataType: 'boolean',
            }),
            new ModelSchema({
                field: 'isBuildInAll',
                name: '',
                fullName: '',
                description: '',
                dataType: 'boolean',
            }),
            new ModelSchema({
                field: 'isDeleted',
                name: '',
                fullName: '',
                description: '',
                dataType: 'boolean',
            }),
            new ModelSchema({
                field: 'modified',
                name: '',
                fullName: '',
                description: '',
                dataType: 'datetime',
            }),
            new ModelSchema({
                field: 'modifiedBy',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'printFileId',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'serviceCode',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'title',
                name: 'Tên quy trình',
                fullName: 'Tên quy trình',
                description: 'Tên quy trình',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'userIdLastInWorkflow',
                name: '',
                fullName: '',
                description: '',
                dataType: 'string',
            }),
            new ModelSchema({
                field: 'version',
                name: '',
                fullName: '',
                description: '',
                dataType: 'int',
            }),
            new ModelSchema({
                field: 'workflowCoreStatus',
                name: '',
                fullName: '',
                description: '',
                dataType: 'int',
            }),

        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'code', width: '30%' }),
            new ColumnSchemaBase({ field: 'title' })
        ];
        this.setting.objectName = 'quy trình';
        super.ngOnInit();
    }
}
